import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'
import styles from './styles.module.scss'

export const TilesDesktop = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <div className='row no-gutters-vertical'>
      {['tile1', 'tile2', 'tile3'].map((key) => (
        <div key={key} className='col-4 d-flex'>
          <div className={`${styles.tileContainer} mc-p-8 mc-corners--md`}>
            <h3 className={`${styles.stepNumber} mc-text--bold mc-mb-4`}>
              {t(`howItWorksTiles.${key}.stepNumber`)}
            </h3>
            <h4 className='mc-text-h2 mc-mb-4'>
              {t(`howItWorksTiles.${key}.title`)}
            </h4>
            <div className={`${styles.underscore} mc-mb-4`}></div>
            <p className='mc-text-h4 mc-text-color--tint mc-mb-4'>
              {t(`howItWorksTiles.${key}.description`)}
            </p>
            <p className='mc-text-small mc-text-color--medium'>
              {t(`howItWorksTiles.${key}.disclaimer`)}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}
